if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const controlsContainers = this.querySelectorAll(".m-slider-controls");
      const prevButtons = this.querySelectorAll(".m-slider-controls__button-prev");
      const nextButtons = this.querySelectorAll(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      const paginationType = this.dataset.paginationType || "bullets";
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.2,
        navigation: this.showNavigation,
        loop: slideItemsLength > 1,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              type: paginationType === "progressbar" ? "progressbar" : "bullets",
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: parseInt(this.items) - 0.5,
          },
          1024: {
            slidesPerView: parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        on: {
          init: function () {
            if (__this.lastActive !== null) {
              if (this.params.loop) {
                this.slideToLoop(__this.lastActive);
              } else {
                this.slideTo(__this.lastActive);
              }
            }
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainers.length > 0) {
                const itemHeight = firstItem.clientHeight;
                controlsContainers.forEach(container => {
                   container.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
                });

                prevButtons.forEach(btn => btn.classList.remove("m:hidden"));
                nextButtons.forEach(btn => btn.classList.remove("m:hidden"));
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainers.length > 0) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainers.forEach(container => container.classList.remove("m:hidden"));
                swiper.allowTouchMove = true;
              } else {
                controlsContainers.forEach(container => container.classList.add("m:hidden"));
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButtons.forEach(btn => btn.addEventListener("click", () => this.slider.slidePrev()));
        nextButtons.forEach(btn => btn.addEventListener("click", () => this.slider.slideNext()));
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        if (this.slider.params.loop) {
          this.slider.slideToLoop(index);
        } else {
          this.slider.slideTo(index);
        }
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
